module.exports = __webpack_public_path__ + "img/wl_sl4.e44cf800.jpg";